import { router } from "@inertiajs/vue3";

// Options API bileşenlerinde her dinleyicinin ömrü onu oluşturan bileşene bağlıdır.
// router.on() DOM callback'i yerine aboneliği kaldıran bir fonksiyon döndürür.
export default {
    data() {
        return { inertiaEventDisposers: [] };
    },
    methods: {
        listenToInertia(event, listener) {
            this.inertiaEventDisposers.push(router.on(event, listener));
        },
    },
    beforeUnmount() {
        // Sayfaya tekrar dönüldüğünde eski analytics/arayüz callback'leri çalışmasın.
        this.inertiaEventDisposers.forEach((dispose) => dispose());
    },
};
